module.exports = __webpack_public_path__ + "static/logistics-planning@3x-60569be6401254e8fbc6c64d5a4ddaed.png";